/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ListPoliciesResponse } from '../models';
// @ts-ignore
import type { Policy } from '../models';
// @ts-ignore
import type { SetPoliciesOrderRequest } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { SyncPoliciesRequest } from '../models';
// @ts-ignore
import type { SyncPoliciesResponse } from '../models';
/**
 * PersistentVolumePolicyAPIApi - axios parameter creator
 * @export
 */
export const PersistentVolumePolicyAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new PV policy for a cluster.
         * @summary Creates a PV policy for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {Policy} policy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPICreatePolicy: async (organizationId: string, clusterId: string, policy: Policy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPICreatePolicy', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPICreatePolicy', 'clusterId', clusterId)
            // verify required parameter 'policy' is not null or undefined
            assertParamExists('persistentVolumePolicyAPICreatePolicy', 'policy', policy)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/pvpolicies`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a PV policy by name.
         * @summary Deletes a PV policy by name.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} name Policy name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPIDeletePolicy: async (organizationId: string, clusterId: string, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIDeletePolicy', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIDeletePolicy', 'clusterId', clusterId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIDeletePolicy', 'name', name)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/pvpolicies/{name}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single PV policy by name.
         * @summary Returns a single PV policy by name.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} name Policy name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPIGetPolicy: async (organizationId: string, clusterId: string, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIGetPolicy', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIGetPolicy', 'clusterId', clusterId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIGetPolicy', 'name', name)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/pvpolicies/{name}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the current set of PV policies for a cluster.
         * @summary Returns PV policies stored for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPIListPolicies: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIListPolicies', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIListPolicies', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/pvpolicies`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the order of PV policies for a cluster.
         * @summary Sets the order of PV policies for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {SetPoliciesOrderRequest} setPoliciesOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPISetPoliciesOrder: async (organizationId: string, clusterId: string, setPoliciesOrderRequest: SetPoliciesOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPISetPoliciesOrder', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPISetPoliciesOrder', 'clusterId', clusterId)
            // verify required parameter 'setPoliciesOrderRequest' is not null or undefined
            assertParamExists('persistentVolumePolicyAPISetPoliciesOrder', 'setPoliciesOrderRequest', setPoliciesOrderRequest)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/pvpolicies:setOrder`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPoliciesOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace all stored PV policies for a cluster with the provided set.  Called periodically by pv-monitor.  Semantics: the request contains the FULL set of policies currently in the  cluster. Policies not in the request are marked as deleted (soft-deleted). Existing policies with  matching name are upserted.
         * @summary Syncs PV policies from an in-cluster agent.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {SyncPoliciesRequest} syncPoliciesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPISyncPolicies: async (organizationId: string, clusterId: string, syncPoliciesRequest: SyncPoliciesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPISyncPolicies', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPISyncPolicies', 'clusterId', clusterId)
            // verify required parameter 'syncPoliciesRequest' is not null or undefined
            assertParamExists('persistentVolumePolicyAPISyncPolicies', 'syncPoliciesRequest', syncPoliciesRequest)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/pvpolicies:sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncPoliciesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing PV policy.
         * @summary Updates a PV policy for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} name Policy name.
         * @param {Policy} policy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPIUpdatePolicy: async (organizationId: string, clusterId: string, name: string, policy: Policy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIUpdatePolicy', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIUpdatePolicy', 'clusterId', clusterId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIUpdatePolicy', 'name', name)
            // verify required parameter 'policy' is not null or undefined
            assertParamExists('persistentVolumePolicyAPIUpdatePolicy', 'policy', policy)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/pvpolicies/{name}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersistentVolumePolicyAPIApi - functional programming interface
 * @export
 */
export const PersistentVolumePolicyAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersistentVolumePolicyAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new PV policy for a cluster.
         * @summary Creates a PV policy for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {Policy} policy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumePolicyAPICreatePolicy(organizationId: string, clusterId: string, policy: Policy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Policy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumePolicyAPICreatePolicy(organizationId, clusterId, policy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumePolicyAPIApi.persistentVolumePolicyAPICreatePolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a PV policy by name.
         * @summary Deletes a PV policy by name.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} name Policy name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumePolicyAPIDeletePolicy(organizationId: string, clusterId: string, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumePolicyAPIDeletePolicy(organizationId, clusterId, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumePolicyAPIApi.persistentVolumePolicyAPIDeletePolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single PV policy by name.
         * @summary Returns a single PV policy by name.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} name Policy name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumePolicyAPIGetPolicy(organizationId: string, clusterId: string, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Policy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumePolicyAPIGetPolicy(organizationId, clusterId, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumePolicyAPIApi.persistentVolumePolicyAPIGetPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the current set of PV policies for a cluster.
         * @summary Returns PV policies stored for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumePolicyAPIListPolicies(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPoliciesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumePolicyAPIListPolicies(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumePolicyAPIApi.persistentVolumePolicyAPIListPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the order of PV policies for a cluster.
         * @summary Sets the order of PV policies for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {SetPoliciesOrderRequest} setPoliciesOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumePolicyAPISetPoliciesOrder(organizationId: string, clusterId: string, setPoliciesOrderRequest: SetPoliciesOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumePolicyAPISetPoliciesOrder(organizationId, clusterId, setPoliciesOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumePolicyAPIApi.persistentVolumePolicyAPISetPoliciesOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace all stored PV policies for a cluster with the provided set.  Called periodically by pv-monitor.  Semantics: the request contains the FULL set of policies currently in the  cluster. Policies not in the request are marked as deleted (soft-deleted). Existing policies with  matching name are upserted.
         * @summary Syncs PV policies from an in-cluster agent.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {SyncPoliciesRequest} syncPoliciesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumePolicyAPISyncPolicies(organizationId: string, clusterId: string, syncPoliciesRequest: SyncPoliciesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncPoliciesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumePolicyAPISyncPolicies(organizationId, clusterId, syncPoliciesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumePolicyAPIApi.persistentVolumePolicyAPISyncPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing PV policy.
         * @summary Updates a PV policy for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} name Policy name.
         * @param {Policy} policy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumePolicyAPIUpdatePolicy(organizationId: string, clusterId: string, name: string, policy: Policy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Policy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumePolicyAPIUpdatePolicy(organizationId, clusterId, name, policy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumePolicyAPIApi.persistentVolumePolicyAPIUpdatePolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PersistentVolumePolicyAPIApi - factory interface
 * @export
 */
export const PersistentVolumePolicyAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersistentVolumePolicyAPIApiFp(configuration)
    return {
        /**
         * Create a new PV policy for a cluster.
         * @summary Creates a PV policy for a cluster.
         * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPICreatePolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPICreatePolicy(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPICreatePolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Policy> {
            return localVarFp.persistentVolumePolicyAPICreatePolicy(requestParameters.organizationId, requestParameters.clusterId, requestParameters.policy, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a PV policy by name.
         * @summary Deletes a PV policy by name.
         * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIDeletePolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPIDeletePolicy(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIDeletePolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.persistentVolumePolicyAPIDeletePolicy(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single PV policy by name.
         * @summary Returns a single PV policy by name.
         * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIGetPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPIGetPolicy(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIGetPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Policy> {
            return localVarFp.persistentVolumePolicyAPIGetPolicy(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the current set of PV policies for a cluster.
         * @summary Returns PV policies stored for a cluster.
         * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPoliciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPIListPolicies(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPoliciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPoliciesResponse> {
            return localVarFp.persistentVolumePolicyAPIListPolicies(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the order of PV policies for a cluster.
         * @summary Sets the order of PV policies for a cluster.
         * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISetPoliciesOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPISetPoliciesOrder(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISetPoliciesOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.persistentVolumePolicyAPISetPoliciesOrder(requestParameters.organizationId, requestParameters.clusterId, requestParameters.setPoliciesOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace all stored PV policies for a cluster with the provided set.  Called periodically by pv-monitor.  Semantics: the request contains the FULL set of policies currently in the  cluster. Policies not in the request are marked as deleted (soft-deleted). Existing policies with  matching name are upserted.
         * @summary Syncs PV policies from an in-cluster agent.
         * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISyncPoliciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPISyncPolicies(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISyncPoliciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SyncPoliciesResponse> {
            return localVarFp.persistentVolumePolicyAPISyncPolicies(requestParameters.organizationId, requestParameters.clusterId, requestParameters.syncPoliciesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing PV policy.
         * @summary Updates a PV policy for a cluster.
         * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumePolicyAPIUpdatePolicy(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Policy> {
            return localVarFp.persistentVolumePolicyAPIUpdatePolicy(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.policy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for persistentVolumePolicyAPICreatePolicy operation in PersistentVolumePolicyAPIApi.
 * @export
 * @interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPICreatePolicyRequest
 */
export interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPICreatePolicyRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPICreatePolicy
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPICreatePolicy
     */
    readonly clusterId: string

    /**
     * 
     * @type {Policy}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPICreatePolicy
     */
    readonly policy: Policy
}

/**
 * Request parameters for persistentVolumePolicyAPIDeletePolicy operation in PersistentVolumePolicyAPIApi.
 * @export
 * @interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIDeletePolicyRequest
 */
export interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIDeletePolicyRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIDeletePolicy
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIDeletePolicy
     */
    readonly clusterId: string

    /**
     * Policy name.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIDeletePolicy
     */
    readonly name: string
}

/**
 * Request parameters for persistentVolumePolicyAPIGetPolicy operation in PersistentVolumePolicyAPIApi.
 * @export
 * @interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIGetPolicyRequest
 */
export interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIGetPolicyRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIGetPolicy
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIGetPolicy
     */
    readonly clusterId: string

    /**
     * Policy name.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIGetPolicy
     */
    readonly name: string
}

/**
 * Request parameters for persistentVolumePolicyAPIListPolicies operation in PersistentVolumePolicyAPIApi.
 * @export
 * @interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPoliciesRequest
 */
export interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPoliciesRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPolicies
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPolicies
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPolicies
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPolicies
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for persistentVolumePolicyAPISetPoliciesOrder operation in PersistentVolumePolicyAPIApi.
 * @export
 * @interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISetPoliciesOrderRequest
 */
export interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISetPoliciesOrderRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISetPoliciesOrder
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISetPoliciesOrder
     */
    readonly clusterId: string

    /**
     * 
     * @type {SetPoliciesOrderRequest}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISetPoliciesOrder
     */
    readonly setPoliciesOrderRequest: SetPoliciesOrderRequest
}

/**
 * Request parameters for persistentVolumePolicyAPISyncPolicies operation in PersistentVolumePolicyAPIApi.
 * @export
 * @interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISyncPoliciesRequest
 */
export interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISyncPoliciesRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISyncPolicies
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISyncPolicies
     */
    readonly clusterId: string

    /**
     * 
     * @type {SyncPoliciesRequest}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISyncPolicies
     */
    readonly syncPoliciesRequest: SyncPoliciesRequest
}

/**
 * Request parameters for persistentVolumePolicyAPIUpdatePolicy operation in PersistentVolumePolicyAPIApi.
 * @export
 * @interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicyRequest
 */
export interface PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicyRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicy
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicy
     */
    readonly clusterId: string

    /**
     * Policy name.
     * @type {string}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicy
     */
    readonly name: string

    /**
     * 
     * @type {Policy}
     * @memberof PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicy
     */
    readonly policy: Policy
}

/**
 * PersistentVolumePolicyAPIApi - object-oriented interface
 * @export
 * @class PersistentVolumePolicyAPIApi
 * @extends {BaseAPI}
 */
export class PersistentVolumePolicyAPIApi extends BaseAPI {
    /**
     * Create a new PV policy for a cluster.
     * @summary Creates a PV policy for a cluster.
     * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPICreatePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumePolicyAPIApi
     */
    public persistentVolumePolicyAPICreatePolicy(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPICreatePolicyRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumePolicyAPIApiFp(this.configuration).persistentVolumePolicyAPICreatePolicy(requestParameters.organizationId, requestParameters.clusterId, requestParameters.policy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a PV policy by name.
     * @summary Deletes a PV policy by name.
     * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIDeletePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumePolicyAPIApi
     */
    public persistentVolumePolicyAPIDeletePolicy(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIDeletePolicyRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumePolicyAPIApiFp(this.configuration).persistentVolumePolicyAPIDeletePolicy(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single PV policy by name.
     * @summary Returns a single PV policy by name.
     * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIGetPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumePolicyAPIApi
     */
    public persistentVolumePolicyAPIGetPolicy(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIGetPolicyRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumePolicyAPIApiFp(this.configuration).persistentVolumePolicyAPIGetPolicy(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the current set of PV policies for a cluster.
     * @summary Returns PV policies stored for a cluster.
     * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumePolicyAPIApi
     */
    public persistentVolumePolicyAPIListPolicies(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIListPoliciesRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumePolicyAPIApiFp(this.configuration).persistentVolumePolicyAPIListPolicies(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the order of PV policies for a cluster.
     * @summary Sets the order of PV policies for a cluster.
     * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISetPoliciesOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumePolicyAPIApi
     */
    public persistentVolumePolicyAPISetPoliciesOrder(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISetPoliciesOrderRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumePolicyAPIApiFp(this.configuration).persistentVolumePolicyAPISetPoliciesOrder(requestParameters.organizationId, requestParameters.clusterId, requestParameters.setPoliciesOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace all stored PV policies for a cluster with the provided set.  Called periodically by pv-monitor.  Semantics: the request contains the FULL set of policies currently in the  cluster. Policies not in the request are marked as deleted (soft-deleted). Existing policies with  matching name are upserted.
     * @summary Syncs PV policies from an in-cluster agent.
     * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISyncPoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumePolicyAPIApi
     */
    public persistentVolumePolicyAPISyncPolicies(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPISyncPoliciesRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumePolicyAPIApiFp(this.configuration).persistentVolumePolicyAPISyncPolicies(requestParameters.organizationId, requestParameters.clusterId, requestParameters.syncPoliciesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing PV policy.
     * @summary Updates a PV policy for a cluster.
     * @param {PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumePolicyAPIApi
     */
    public persistentVolumePolicyAPIUpdatePolicy(requestParameters: PersistentVolumePolicyAPIApiPersistentVolumePolicyAPIUpdatePolicyRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumePolicyAPIApiFp(this.configuration).persistentVolumePolicyAPIUpdatePolicy(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.policy, options).then((request) => request(this.axios, this.basePath));
    }
}

